const generatePassword = ({ length = 10, charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ01234567891234567890@%&$^#!" } = {}) => {
    const chars = charset    
    let password = "";
    for (var i = 0, n = chars.length; i < length; ++i) {
        password += chars.charAt(Math.floor(Math.random() * n));
    }
    return password;
}

export {generatePassword}